import EmptySection from './EmptySectionUpdatedForOnBoarding';
import { EmptySectionUpdatedForOnBoarding } from './EmptySectionUpdatedForOnBoarding';

// export default EmptySectionUpdatedForOnBoarding;
// EmptySection;

export default EmptySection;
